<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">比赛游戏配置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="30px" class="user-search">
            <el-form-item label=" ">
                <el-button size="small" type="primary" @click="addClick">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row border style="width:800px">
        <el-table-column  prop="gameName" label="游戏名称" align="center" ></el-table-column>
        <el-table-column  prop="id" label="游戏ID" align="center" ></el-table-column>
        <el-table-column  prop="statisticsType" label="统计方式" align="center" ></el-table-column>
        <el-table-column  prop="signNum" label="报名方式" align="center" ></el-table-column>
        <el-table-column  prop="unit" label="单位" align="center" ></el-table-column>
        <el-table-column align="center" label="操作" >
            <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" v-preventReClick @click="delClick(scope.row)">删除</el-button>
            </template>
        </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->

        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="addForm" :rules="rules" ref="addForm">
                <el-form-item label="游戏：" prop="id">
                    <el-select v-model="addForm.id" @change="gamesSlChange" placeholder="请选择">
                        <el-option v-for="item in gamesList" :key="item.gameID" :label="item.name"  :value="item.gameID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报名方式：" prop="signNum">
                    <el-radio-group v-model="addForm.signNum">
                        <el-radio :label="1">1人报名</el-radio>
                        <el-radio :label="2">2人报名</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="统计方式：" prop="statisticsType">
                    <el-radio-group v-model="addForm.statisticsType">
                        <el-radio :label="1">按小结算统计局数</el-radio>
                        <el-radio :label="2">按大结算统计局数</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="单位：" prop="units">
                    <el-checkbox-group v-model="addForm.units" @change="checkboxChange">
                        <el-checkbox v-for="item in MethodData" :key="item.unit" :label="item.unit">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <!-- <el-form-item label="行业">
                    <el-radio-group v-model="radio" @change="radioChange">
                        <el-radio  v-for="item in MethodData" :key="item.unit" :label="item.unit">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item> -->
            
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editFormVisible = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="submitForm('addForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import Pagination from '../../components/Pagination'
import { loadTradeList , saveTrade , deleteTrade } from '../../api/userMG'
import { matchgameList , matchgameSelect , matchgameAdd , matchgameDel} from '../../api/competition'
import { CompetitionMethodData, CompetitionMethodNum } from '../../utils/CompetitionMethod'
export default {
    data () {
        return {
            gamesList:[],
            addForm:{
                units:[]
            },
            loading:false,
            rules:{},
            editFlag:false,
            editForm:{
                name:'',
                id:'',
            },
            editFormVisible:false,
            content: '',
            editorOption: {
            // Some Quill options...
            },
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            rules: {
                id: [
                    { required: true, message: '请选择游戏', trigger: 'blur' }
                ],
                signNum:[
                    { required: true, message: '请选择报名人数', trigger: 'blur' }
                ],
                statisticsType:[
                    { required: true, message: '请选择统计方式', trigger: 'blur' }
                ],
                units:[
                    { required: true, message: '请选择单位', trigger: 'blur' }
                ],
            },
            MethodData:[],
            checkList:[],
            radio:''
        }
    },
    components: {
        Pagination
    },
    created(){
        console.log(CompetitionMethodData())
        this.MethodData = CompetitionMethodData()
        this.getdata()
        this.getMatchgameList()
    },
    methods: {
        getMatchgameList(){
            matchgameList().then(res=>{
                this.gamesList = res.data.datas
            })
        },
        gamesSlChange(e){
            let data = this.gamesList.find(item => item.gameID === e)
            this.addForm.gameType = data.gameType
            this.addForm.gameName = data.name

        },
        radioChange(e){
            console.log(CompetitionMethodNum(e))

        },
        delClick(row){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                matchgameDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },  
        addClick(){
            this.editFlag = false
            this.editFormVisible = true
            this.addForm = {
                units:[],
                statisticsType:'',
                signNum:'',
                id:'',
            }
        },  
        submitForm(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    let data = JSON.parse(JSON.stringify(this.addForm))
                    let unit = 0 
                    this.addForm.units.forEach(item =>{
                        unit += item
                    })
                    console.log(unit)
                    data.unit = unit
                    matchgameAdd(data).then(res=>{
                        if(!res.success){
                            this.$message.error(res.messages)
                        }else {
                            this.$message.success(this.editForm.id == ''?'创建成功':'修改成功')
                            this.getdata()
                            this.editFormVisible = false
                        }
                    })
                } else {
                    return false
                }
            })
        },  

        
        handleEdit(row){
            console.log(row)
            let data = []
            this.MethodData.forEach(item=>{
                console.log(item)
                if((row.unit&item.unit) != 0){
                    data.push(item.unit)
                }
            })
            this.addForm = {
                gameName:row.gameName,
                id:row.id,
                gameType:row.gameType,
                signNum:row.signNum,
                statisticsType:row.statisticsType,
                units:data,
            }
            this.editFormVisible = true
        },
        closeDialog(){
            this.$refs.editForm.clearValidate();
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        getdata(){
            matchgameSelect().then(res=>{
                this.listData = res.data
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    },
    computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		}
    },
    mounted() {
    // console.log('this is current quill instance object', this.editor)
    },
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/system/CompetitionGame.vue